import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M14.868 4.614a6.375 6.375 0 0 1-2.743 7.164 11.1 11.1 0 0 1 5.231 3.496.74.74 0 0 1-.093 1.05.73.73 0 0 1-1.05-.093 9.77 9.77 0 0 0-14.944 0 .75.75 0 0 1-1.144-.957 11.1 11.1 0 0 1 5.231-3.496 6.375 6.375 0 1 1 9.512-7.164M8.74 1.502a4.875 4.875 0 1 0 0 9.75 4.875 4.875 0 0 0 0-9.75m13.143 8.916-.43-.253c.05-.273.05-.552 0-.825l.43-.253a.74.74 0 0 0 .282-1.022.76.76 0 0 0-1.032-.272l-.43.253a2.3 2.3 0 0 0-.713-.412v-.507a.75.75 0 0 0-1.5 0v.507c-.261.092-.503.232-.713.412l-.431-.253a.76.76 0 0 0-1.031.272.74.74 0 0 0 .28 1.022l.432.253c-.05.273-.05.552 0 .825l-.431.253a.75.75 0 0 0 .375 1.397.7.7 0 0 0 .375-.103l.431-.253c.21.18.452.32.713.412v.506a.75.75 0 0 0 1.5 0v-.506a2.3 2.3 0 0 0 .712-.412l.431.253a.7.7 0 0 0 .375.103.75.75 0 0 0 .375-1.397m-2.643-1.416a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }